// extracted by mini-css-extract-plugin
module.exports = {"headline":"H1_headline__WAerm"};